export default __webpack_public_path__ + "static/kr-6c83e671d1cc96f69ed3daad1006e20f.jpeg";